import { NewIamHelper } from '../../shared/components/helpers';

(function () {
    'use strict';

    angular
        .module('employeeControllers')
        .controller('EmployeeAllProfilesController', Controller);

    Controller.$inject = ['$location', '$state', 'employeeService'];

    function Controller($location, $state, employeeService, authenticatedUser) {
        if (!$state.is('profile')) { return; }

        employeeService
            .getEmployeeIDByAuthentication()
            .then(function (identity) {
                NewIamHelper.navigateTo('profile.employee', identity.EmployeeID);
            });
    }
})();
